export default "__VITE_ASSET__CZ$R$Ej$__"